import { Outlet, useRouteLoaderData } from 'react-router-dom';
import Content, { TabProps } from '../../components/content';
import { LoginResponseDto } from '../../lib/api';
import { LayoutGrid } from 'lucide-react';

const pageTabs: TabProps[] = [
    { label: 'overview', link: '/organization/overview' },
    { label: 'user management', link: '/organization/user-management' },
];

export function OrganizationLayout() {
    const session = useRouteLoaderData('root') as LoginResponseDto;
    return (
        <Content headerTitle={session?.activeOrg?.name} headerIcon={<LayoutGrid size="20" />} tabs={pageTabs}>
            {{
                content: <Outlet />,
            }}
        </Content>
    );
}
